<template>
  <div class="image-preview-button">
    <div
      class="image-wrap"
      :style="{backgroundImage: 'url(' + _image + ')' }"
      :class="{small:small,cancel:cancel,medium:medium}"
      @click="previewPopUpOpen()"
    >
      <i
        v-if="!isloading"
        class="icon-cancel delete"
        @click.stop="deleteFile()"
      />
      <div
        v-if="isloading"
        class="isloading-wrap"
      >
        <!-- <WsLoading primary /> -->
        <WsReloadCircleProgress001
          :range="percent"
          :size="20"
          primary
        />
      </div>
      <div
        v-if="isloading"
        class="isloading-bg"
      />
    </div>
    <WsPreviewPopUp001
      :pop-up-active="previewPopUpActive"
      :text-label="textLabel"
      download
      @click="previewPopUpClose()"
    />
  </div>
</template>
<script>
import H_file from '@/helpers/file';
import Spare_file from '@/spare/file';

export default {
  name: "WsImagePreviewButton001",
  props: {
    image: {
      type: [String, Object],
    },
    cancel: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    textLabel: {
      type: String,
      default: "",
    },
    previewUrl: {
      type: String,
      default: "",
    },
    medium: {
      type: Boolean,
      default: false,
    },
    isloading: {
      type: Boolean,
      default: false,
    },
    percent: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    previewPopUpActive: false,
  }),
  computed: {
    _image() {
      if (this.isloading) {
        return this.previewUrl;
      } else {
        if (this.image.url) {
          return this.image.url;
        } else {
          return this.image;
        }
        // return this.textLabel;
      }
    },
    _isImage() {
      const url = this._image;
      const fileExtension = H_file.setFileExtension(url);
      const imageExtensions = Spare_file.imageExtensions;
      return imageExtensions.includes(fileExtension);
    }
  },
  methods: {
    previewPopUpClose() {
      this.previewPopUpActive = false;
      this.$emit("scroll-click");
    },
    previewPopUpOpen() {
      if (this.isloading) return;
      this.previewPopUpActive = true;
      this.$emit("no-scroll");
    },
    deleteFile() {
      this.$emit("click");
    },
  },
};
</script>